/* eslint-disable */ // Used only for files created before adding the linter -> please remove when changing the file!
import {Component, Element, h, Host, Prop, State, Env} from '@stencil/core';
import {getConfiguration} from "../../global/environment-variable-helper";
import {APIResultVideo, getMi24Videos} from "./videosApiRequest";
import mi24VideoHelper from "../ifx-mi24-video/mi24-video-helper";

interface Row {
  element,
  teasers: [],
  oldTitles: HTMLElement[],
  newTitles: HTMLElement[]
}

@Component({
  tag: 'ifx-teaser-row',
  styleUrl: 'ifx-teaser-row.scss',
  shadow: false,
})
export class IfxTeaserRow {
  @Element() host: HTMLDivElement;
  @Prop({reflect: true}) heading: string;
  @Prop({reflect: true}) countCols: number = 3;
  @Prop({reflect: true}) numberOfVideos?: number;
  @State() translations: any;
  @State() videos: APIResultVideo[];
  env: any;

  // title constants
  rows: Row[] = [];
  originalTeaserrow;
  teaserParentClassList;
  columnColClasses;
  breakpoint;

  componentWillLoad() {
    this.initConfigurationsAndSettings();
  }

  private initConfigurationsAndSettings() {
    this.env = getConfiguration(Env.environment);
    this.setAllVideoPropertiesIfNeeded();
  }

  async setAllVideoPropertiesIfNeeded() {
    // use alternative title/description, else from BE
    if (typeof this.numberOfVideos != 'undefined' && this.numberOfVideos >= 1) {

      let slottedVideos = this.host.querySelectorAll('ifx-mi24-video');

      let videoIds = Array.prototype.slice.call(slottedVideos).map(videoNode => videoNode.attributes['video-id'].value);

      this.videos = await getMi24Videos(this.env.getVideosUrl, [videoIds.join()], 'Getting the videos has failed', []);

      if (this.videos.length != 0) {
        slottedVideos.forEach(videoNodeToUpdate => {
          const videoId = videoNodeToUpdate.attributes['video-id'].value;

          mi24VideoHelper.setVideoPropertiesFromBackendIfNeeded(videoNodeToUpdate, this.videos, videoId);
        });
      }
    }
  }

  render() {
    return (
      <Host>
        <h2>{this.heading}</h2>
        <div class={"row teaserrow wrapper-cols-" + this.countCols}>
          <slot></slot>
        </div>
      </Host>
    );
  }

  // To align the images/videos in a row, we have to create a new, separate row for the titles
  // So the position of the images/videos won't depend on their titles
  componentDidLoad() {
    // We have to wait until the subcomponents are loading too
    const ifxComponentVideos = this.host.querySelectorAll('ifx-mi24-video');
    if(ifxComponentVideos.length > 0) {
      const self = this;
      let loopCounter = 0;
      let waitForVideoComponentLoading = setInterval(function() {
        //we have to wait until the title of the videos are loaded to handle them
        const readyVideoComponents = self.host.querySelectorAll('ifx-mi24-video h3');
        //check if all video component was loaded by Stencil
        if(ifxComponentVideos.length === readyVideoComponents.length) {
          clearInterval(waitForVideoComponentLoading);
          self.handleTitles();
        }
        // prevent infiniteLoop: we wait maximum for 5 secs
        if(loopCounter > 5000) {
          clearInterval(waitForVideoComponentLoading);
        } else {
          loopCounter += 100;
        }
      }, 100);
    } else {
      this.handleTitles();
    }
  }

  handleTitles() {
    this.setTitleConstants();
    this.rows.forEach(row => {
      // Check if the title handling is needed and the needed parameters are existing with the right format
      // needed: h3 titles, teasers with teaser classes and column-col-classes for proper display
      if (row.oldTitles.length > 0 && row.teasers.length > 0 && this.columnColClasses.length > 0) {
        this.initNewTitles(row);
      }
    })

    const self = this;
    this.updateColumnTitles();
    // When the window is under the smallest breakpoint, we have to use the original titles
    // And vice versa
    window.addEventListener('resize', function() {
      self.updateColumnTitles();
    }, true);
  }

  // Get the needed data for the title settings (run only once)
  setTitleConstants() {
    this.originalTeaserrow = this.host.querySelector('.teaserrow');
    let rows = this.originalTeaserrow.querySelectorAll('.row:not(.teaserrow)');
    if (!rows.length) {
      rows = [this.originalTeaserrow];
    }

    const self = this;
    rows.forEach(row => {
      self.rows.push({
        element: row,
        teasers: row.querySelectorAll('.teaser'),
        oldTitles: row.querySelectorAll('h3'),
        newTitles: []
      })
    })

    const teaser = this.host.querySelector('.teaser');
    if(teaser) {
      this.teaserParentClassList = Array.from(teaser.parentElement.classList);
    }
    this.columnColClasses = teaser ? teaser.classList.value.split(' ').filter(el => el.includes('col')) : [];
    this.breakpoint = this.getBreakpoint();
  }

  getViewportWidth(): number {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  // Create a new row, under the component's title, but above the columns
  // Copy the column titles there
  // We will display the needed one, with updateColumnTitles() method
  initNewTitles(row) {
    row.oldTitles.forEach(el => {
      row.newTitles.push(el.cloneNode(true));
    });

    const titleRow = document.createElement('div');

    // reuse the classes of teasers' parent, so the teasers will be in the proper position
    this.teaserParentClassList.forEach(el => {
      titleRow.classList.add(el);
    });
    // add videoteaser class to handle the gated-video titles properly
    if (this.numberOfVideos) {
      titleRow.classList.add('videoteaser');
    }
    const self = this;
    row.newTitles.forEach(el => {
      self.columnColClasses.forEach(classEl => {
        el.classList.add(classEl);
      })
      titleRow.append(el);
    });

    //Prevent share-button re-rendering
    const shareButton = titleRow.querySelectorAll("ifx-share-button")
    if (shareButton) {
      shareButton.forEach(el =>{
        const shareButtonSlotNode = el.querySelector(".icon-wrapper").nextElementSibling.cloneNode(true);
        el.innerHTML = "";
        el.appendChild(shareButtonSlotNode);
      })
    }

    row.element.prepend(titleRow);
  }

  setOldTitles(display) {
    this.rows.forEach(row => {
      if (row.oldTitles.length > 0) {
        row.oldTitles.forEach(el => {
          el.style.display = display ? 'block' : 'none';
        });
      }
    })
  }

  setNewTitles(display) {
    this.rows.forEach(row => {
      if (row.newTitles.length > 0) {
        row.newTitles[0].parentElement.style.display = display ? 'block' : 'none';
      }
    })
  }

  useOriginalTitles() {
    this.setOldTitles(true);
    this.setNewTitles(false);
  }

  useNewRowForTitles() {
    this.setNewTitles(true);
    this.setOldTitles(false);
  }

  // Get the smallest breakpoint of the columns, under that, we have to use the original titles
  getBreakpoint() {
    if (this.columnColClasses.filter(el => el.includes('col-xs')).length > 0) {
      return 600;
    }
    if (this.columnColClasses.filter(el => el.includes('col-sm')).length > 0) {
      return 768;
    }
    if (this.columnColClasses.filter(el => el.includes('col-md')).length > 0) {
      return 1024;
    }
    if (this.columnColClasses.filter(el => el.includes('col-lg')).length > 0) {
      return 1280;
    }
    return 10000;
  }

  updateColumnTitles() {
    if (this.getViewportWidth() < this.breakpoint) {
      this.useOriginalTitles();
    } else {
      this.useNewRowForTitles();
    }
  }
}
